import { render } from "./GesPostales.vue?vue&type=template&id=58a44c51&scoped=true"
import script from "./GesPostales.vue?vue&type=script&lang=js"
export * from "./GesPostales.vue?vue&type=script&lang=js"

import "./GesPostales.vue?vue&type=style&index=0&id=58a44c51&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58a44c51"

export default script